import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    filter: () =>
    AxiosInstance.get<any[]>(`${Config.core.documentTypes}`,
      {params: {
        "isPublic.equals": true,
        "sort": "idDocumentTypeERP"
      }}
    )
}